import DialogLocked from '~/components/dialog/locked/DialogLocked.vue';
export type DialogLockedContent = {
  title: string;
  description: number;
};
export const useDialogLockedContent = () => {
  const dialog = useDialogStore();
  const { t } = useNuxtApp().$i18n;
  const isOpen = ref<boolean>(false);
  const open = (title: String, backUrl?: string, onClose?: () => void) => {
    isOpen.value = true;
    dialog.open(DialogLocked, {
      level: DialogLevel.Info,
      title,
      description: t('locked.popin.description'),
      onClose: () => {
        if (backUrl) navigateTo(backUrl);
        if (onClose) onClose();
        isOpen.value = false;
      },
    });
  };
  const close = () => {
    dialog.close();
  };
  return {
    open,
    close,
    isOpen,
  };
};
